import http from "~/common/http";


const TARGET_TYPE_ORDER = 1; // 目标类型订单
const TARGET_TYPE_CUSTOMER = 2; // 目标类型客户
const TARGET_TYPE_CLUE = 3; // 目标类型线索
const TARGET_TYPE_PAY = 4; // 目标类型财务

export default {

    /**
     * 获取未读消息列表
     * @param params
     * @returns {*}
     */
    getMyUnreads(params) {
        return http.get('/api/message/my-unreads', {
            params: params
        });
    },

    /**
     * 获取已读消息列表
     * @param params
     * @returns {*}
     */
    getMyHasReads(params) {
        return http.get('/api/message/my-has-reads', {
            params: params
        });
    },

    /**
     * 获取全部消息列表
     * @param params
     * @returns {*}
     */
    getAllMessage(params) {
        return http.get('/api/message/index', {
            params: params
        })
    },

    /**
     * 批量设为已读
     * @param params
     */
    batchSetRead(params) {
        return http.post('/api/message/batch-set-read', params);
    },

    /**
     * 批量删除
     * @param params
     * @returns {*}
     */
    batchDelete(params) {
        return http.post('/api/message/batch-delete', params);
    },

    readTarget(targetId, targetType) {
        return http.get('/api/message/read-target', {
            params: {
                target_id: targetId,
                target_type: targetType
            }
        })
    },

    /**
     * 读取订单消息
     * @param $vm
     * @returns {*}
     */
    readOrderMessage($vm) {
        if ($vm.$route.query['id'] > 0 && $vm.$route.query['referer'] == 'message') {
            return this.readTarget($vm.$route.query['id'], TARGET_TYPE_ORDER);
        }
        return;
    },

    /**
     * 读取客户消息
     * @param $vm
     * @returns {*}
     */
    readCustomerMessage($vm) {
        if ($vm.$route.query['id'] > 0 && $vm.$route.query['referer'] == 'message') {
            return this.readTarget($vm.$route.query['id'] , TARGET_TYPE_CUSTOMER);
        }
        return;
    },

    /**
     * 读取线索消息
     * @param $vm
     * @returns {*}
     */
    readClueMessage($vm) {

        console.log('id >>', $vm.$route.query['id']);
        console.log('referer >>', $vm.$route.query['referer']);

        if ($vm.$route.query['id'] > 0 && $vm.$route.query['referer'] == 'message') {
            return this.readTarget($vm.$route.query['id'], TARGET_TYPE_CLUE);
        }
        return;
    }



};


// WEBPACK FOOTER //
// ./src/services/Message.js